import { factory } from '../positions/asset-position-details/asset-position-details-container';

export default factory({
  rowFragmentExtend: {
    initialCommitment: true,
    unfundedCommitment: true,
    purchaseValue: true,
    totalCapitalCall: true,
    totalDistribution: true,
    capitalBalance: true,
  },
  mapperExtend: ({ currency }) => ({
    initialCommitmentUnit: currency,
    unfundedCommitmentUnit: currency,
    purchaseValueUnit: currency,
    totalCapitalCallUnit: currency,
    totalDistributionUnit: currency,
    capitalBalanceUnit: currency,
  }),
});
